/**
 * Created by falknisius on 11.05.17.
 */

import '../App.css'

import getString from '../config/strings'

import React from 'react'
import Page from '../components/Page'
import Button from '@material-ui/core/Button'
import APIService from '../services/APIService'
import { register as registerForGroup } from '../services/QDGroupService'
import Textfield from '@material-ui/core/TextField'
import CircularProgress from '@material-ui/core/CircularProgress'
import MessageService from '../services/MessageService'
import { COLORS, DEFAULT_IMAGE, SCREENS, TOURNAMENT_PHASES, TOURNAMENT_PHASES_TRANSLATIONS } from '../config/constants'
import ButtonBase from '@material-ui/core/ButtonBase/ButtonBase'
import Paper from '@material-ui/core/Paper/Paper'
import Highcharts from 'highcharts'

import {
  HighchartsChart, Chart, withHighcharts, XAxis, YAxis, Title, Legend,
  AreaSplineSeries, SplineSeries, BarSeries, Navigator, RangeSelector, Tooltip
} from 'react-jsx-highcharts'
import InputLabel from '@material-ui/core/InputLabel/InputLabel'
import FormControl from '@material-ui/core/FormControl/FormControl'
import Input from '@material-ui/core/Input/Input'
import Table from '@material-ui/core/Table/Table'

const OLD_GAME_TRESHHOLD = 60000
const OLD_TOURNAMENT_TRESHHOLD = 600000 // 3600000

class Home extends Page {

  constructor (props, context) {
    super(props, context)
    this.storeKeys.push('queryParams')
    this.state = {
      tournamentData: {},
      activated: false,
      activationCode: '',
      gotTournamentData: false,
      tournamentChosen: false,
      chosenTournament: null,
      tournamentList: [],
      phase: null,
      error: null,
      runningTime: null,
      runningGames: [],
      users: {},
      deviceChannelOpened: false,
      teamPoints: null,
      showExtraTimeWarning: true,
      singleGameViewOpen: false
    }

    this.runningTimeInterval = null
  }

  componentDidMount () {
    document.addEventListener('online', this.getTournamentData)
  }

  componentDidUpdate (prevProps, prevState) {
    if (this.state.deviceUuid && !this.state.deviceChannelOpened) {
      MessageService.registerChannel('private:equeoqd:' + this.state.deviceUuid, this.onMessageForThisApp)
    }
  }

  onMessageForThisApp = async message => {
    console.log('ABLY: message for this device arrived', message)
    const command = message.name

    if (command === 'roundPlayed' || command === 'gameFinished') {
      console.log('ABLY: get new game with id', message)
      if (message.data && message.data.gameId) {
        const runningGames = this.state.runningGames
        const updatedGame = await APIService.getRunningGames(this.state.activationCode, this.state.chosenTournament.id, message.data.gameId, this.state.deviceUuid)
        runningGames[updatedGame.game.emsId] = updatedGame.game
        console.log('updatedGame runningGames', runningGames)
        this.setState({runningGames: runningGames})

        if (message.data.teamPoints) {
          console.log('setting team points on ably message', message.data.teamPoints)
          this.setState({teamPoints: message.data.teamPoints})
        }

        if (command === 'gameFinished') {
          this.getTournamentData()
        }
      }
    }
    else if (command === 'updateTournament') {
      console.log('ABLY: get updated tournament data', message)
      this.getTournamentList()
      this.getTournamentData()

      if (message.data.teamPoints) {
        console.log('setting team points on ably message', message.data.teamPoints)
        this.setState({teamPoints: message.data.teamPoints})
      }
    }
    else if (command === 'startTournament') {
      this.getTournamentList()
    }
  }

  changeActivationCode = (evt) => {
    this.setState({activationCode: evt.target.value})
  }

  chooseTournament = (tournament) => {
    this.setState({tournamentChosen: true, chosenTournament: tournament}, this.getTournamentData)
    console.log('chooseTournament', this.state.activationCode, tournament.id, this.state.deviceUuid)
    if (tournament.phase !== TOURNAMENT_PHASES.END) {
      try {
        APIService.registerForAblyMessages(this.state.activationCode, tournament.id, this.state.deviceUuid)
      }
      catch (error) {
        console.log('error registering for tournament ably messages', error)
      }
    }
  }

  getTeamName (tournament, index) {
    if (!tournament) {
      return ''
    }
    const teams = tournament.teams ? Object.values(tournament.teams) : null
    if (teams && teams.length > index) {
      return teams[index].name
    }
    return ''
  }

  showTournamentChooser = () => {
    const now = Date.now()

    const runningTournaments = []
    const finishedTournaments = []

    this.state.tournamentList.forEach(tournament => {
      if (tournament.phase === TOURNAMENT_PHASES.END) {
        finishedTournaments.push(tournament)
      }
      else {
        runningTournaments.push(tournament)
      }
    })

    const styles = this.getStyles()

    return (
      <div style={styles.boxStyle}>
        <div style={styles.titleStyle}>Turnier auswählen</div>
        {runningTournaments.length > 0 && runningTournaments.map(tournament => {
          return (
            <ButtonBase
              focusRipple
              key={tournament.id}
              style={{
                width: '100%',
                marginBottom: 15
              }}
              onClick={() => this.chooseTournament(tournament)}
            >
              <Paper className={'paperRoot'} elevation={2} style={{padding: '10px', width: '100%'}}>
                <div className={'paper'}>
                  <div className={'title'}>{tournament.name}</div>
                  <div className={'subtitle'}>{TOURNAMENT_PHASES_TRANSLATIONS[tournament.phase]}</div>
                  <div className={'subtitle'}>{this.getTeamName(tournament, 0)} vs. {this.getTeamName(tournament, 1)}</div>
                </div>
              </Paper>
            </ButtonBase>
          )
        })}
        {finishedTournaments.length > 0 && finishedTournaments.map(tournament => {
          const tournamentEnd = Date.parse(tournament.endTournament)
          console.log('tournamentEnd', tournament, tournamentEnd, now, now - tournamentEnd)
          if (tournament.phase === TOURNAMENT_PHASES.END && now - tournamentEnd < OLD_TOURNAMENT_TRESHHOLD) {
            return (
              <ButtonBase
                focusRipple
                key={tournament.id}
                style={{
                  width: '100%',
                  marginBottom: 15
                }}
                onClick={() => this.chooseTournament(tournament)}
              >
                <Paper className={'paperRoot'} elevation={2} style={{padding: '10px', color: 'white', width: '100%'}}>
                  <div className={'paperFinished'}>
                    <div className={'title'}>{tournament.name}</div>
                    <div className={'subtitle'}>{TOURNAMENT_PHASES_TRANSLATIONS[tournament.phase]}</div>
                    <div className={'subtitle'}>{this.getTeamName(tournament, 0)} vs. {this.getTeamName(tournament, 1)}</div>
                  </div>
                </Paper>
              </ButtonBase>
            )
          }
        })}
      </div>
    )
  }

  getTournamentList = async () => {
    try {
      const data = await APIService.getTournamentList(this.state.activationCode, this.state.deviceUuid)
      console.log('got tournament list', data)
      if (data.tournaments && data.tournaments.length > 0) {
        this.setState({tournamentList: data.tournaments})
        this.showTournamentChooser()
      }
    }
    catch (error) {
      this.setState({error: error.message, activated: false})
    }
  }

  msToTime = (duration) => {
    let seconds = parseInt((duration / 1000) % 60, 10)
    let minutes = parseInt((duration / (1000 * 60)) % 60, 10)
    let hours = parseInt((duration / (1000 * 60 * 60)) % 24, 10)

    minutes = (minutes < 10) ? '0' + minutes : minutes
    seconds = (seconds < 10) ? '0' + seconds : seconds

    return hours + ':' + minutes + ':' + seconds
  }

  calculateTime = (startDate) => {
    const startTimeStamp = new Date(startDate).getTime()

    this.runningTimeInterval = setInterval(() => {
      const currentTimeStamp = Date.now()
      const runningTime = currentTimeStamp - startTimeStamp
      const timeToShow = this.msToTime(runningTime)
      this.setState({runningTime: timeToShow})
    }, 1000)
  }

  getTournamentData = async () => {
    if (!this.state.chosenTournament) {
      return
    }
    try {
      let runningGames = {}
      let users = {}
      const data = await APIService.getTournamentData(this.state.chosenTournament.id, this.state.activationCode, this.state.deviceUuid)
      registerForGroup(this.onMessageForThisApp, data.tournament.group)
      if (data.tournament.teams && Object.keys(data.tournament.teams).length > 0) {
        Object.keys(data.tournament.teams).forEach(teamKey => {
          const team = data.tournament.teams[teamKey]
          const members = team.members

          if (members && members.length > 0) {
            members.forEach(async singleMember => {
              const userImage = await this.getUserImageById(singleMember.id, data.tournament.id)
              if (userImage) {
                singleMember.image = userImage
              }
              users[singleMember.id] = singleMember
            })
          }
        })
      }

      if (data.tournament.phase === TOURNAMENT_PHASES.PLAY_GAMES || data.tournament.phase === TOURNAMENT_PHASES.WAIT_FOR_END) {
        // if (this.state.runningTime === null) {
        //   console.log('starting timer')
        //   this.calculateTime(data.tournament.startPlaying)
        // }
        const runningGamesResponse = await APIService.getRunningGames(this.state.activationCode, this.state.chosenTournament.id, null, this.state.deviceUuid)
        Object.keys(runningGamesResponse.games).forEach(gameKey => {
          const game = runningGamesResponse.games[gameKey]
          runningGames[game.emsId] = game
        })
      }
      else if (data.tournament.phase !== TOURNAMENT_PHASES.PLAY_GAMES) {
        clearInterval(this.runningTimeInterval)
      }
      console.log('set running games', runningGames)
      this.setState({tournamentData: data.tournament, gotTournamentData: true, phase: data.tournament.phase, runningGames: runningGames, users: users})
    }
    catch (error) {
      this.setState({error: error.message, activated: false})
    }
  }

  resetActivationCodeEntry = () => {
    this.setState({activationCode: ''})
  }

  activate = async () => {
    try{
      const response = await APIService.checkActivationCode(this.state.activationCode, this.state.deviceUuid)
      if (response.success) {
        this.setState({activated: true, error: null})
        APIService.getThemeAndGroupName(this.state.activationCode, this.state.deviceUuid)
        this.getTournamentList()
      }
    }
    catch (error) {
      this.setState({error: error.message})
    }
  }

  getUserImageById = async (userId, tournamentId) => {
    const userImage = await APIService.getUserImage(tournamentId, userId, this.state.activationCode, this.state.deviceUuid)
    return userImage.picture
  }

  renderGame = (team1Name, team2Name, game, isChallenger, index) => {

    // if (game.hasOwnProperty('type') && game.type === 'emptyGame') {
    //   return <td style={{width: '9%', textAlign: 'center',  color: '#0F3764', fontSize: '24px', fontWeight: 'bold', padding: '10px 0'}}>&nbsp;</td>
    // }

    const challenger = this.state.users[game.challenger]
    const opponent = this.state.users[game.opponent]
    const challengerPointsPerRound = {}
    let challengerTotalPoints = 0
    const opponentPointsPerRound = {}
    let opponentTotalPoints = 0
    //
    // if (!challenger || !opponent) {
    //   return null
    // }

    if (game.rounds && game.rounds.length > 0) {
      game.rounds.map(round => {
        challengerPointsPerRound[round.number] = 0
        opponentPointsPerRound[round.number] = 0

        if (round.state && round.state.challenger && round.state.challenger.length > 0) {
          round.state.challenger.forEach(question => {
            if (question.score === 1) {
              challengerPointsPerRound[round.number] += question.score
              challengerTotalPoints += question.score
            }
            else {
              challengerPointsPerRound[round.number] += 0
            }
          })
        }
        if (round.state && round.state.opponent && round.state.opponent.length > 0) {
          round.state.opponent.forEach(question => {
            if (question.score === 1) {
              opponentPointsPerRound[round.number] += question.score
              opponentTotalPoints += question.score
            }
            else {
              opponentPointsPerRound[round.number] += 0
            }
          })
        }
      })
    }

    const sortedRounds = game.rounds.sort(
      (contentA, contentB) => {
        if (contentA.number > contentB.number) {
          return 1
        }
        else if (contentA.number < contentB.number) {
          return -1
        }
        return 0
      }
    )

    console.log('game', game)
    let challengerRounds = []
    let opponentRounds = []

    for (let i = 0; i < game.maxRounds; i++) {
      if (game.rounds && game.rounds[i]) {
        if (game.rounds[i].state && game.rounds[i].state.challenger && game.rounds[i].state.challenger.length > 0) {
          challengerRounds.push(true)
        }
        else {
          challengerRounds.push(false)
        }

        if (game.rounds[i].state && game.rounds[i].state.opponent && game.rounds[i].state.opponent.length > 0) {
          opponentRounds.push(true)
        }
        else {
          opponentRounds.push(false)
        }
      }
      else {
        opponentRounds.push(false)
        challengerRounds.push(false)
      }
    }

    const roundsToMap = isChallenger ? challengerRounds : opponentRounds

    return <td style={{width: '40%', textAlign: 'left', fontSize: '24px', fontWeight: 'bold', padding: '10px'}}>
      <div style={{fontSize: '18px', fontWeight: '400'}}>{isChallenger ? challenger && challenger.nickname ? challenger.nickname : 'User1' : opponent && opponent.nickname ? opponent.nickname : 'User2'}</div>
      <div>
        {
          roundsToMap.map((round, index) => {
            if (round) {
              return (
                <div
                  key={`challenger_${index}`}
                  style={{
                    display: 'inline-block',
                    marginRight: '3px',
                    width: '12px',
                    height: '12px',
                    borderRadius: '20px',
                    backgroundColor: COLORS.done
                  }}/>
              )
            }
            else {
              return (
                <div
                  key={`challenger_${index}`}
                  style={{
                    display: 'inline-block',
                    marginRight: '3px',
                    width: '12px',
                    height: '12px',
                    borderRadius: '20px',
                    backgroundColor: COLORS.open,
                    opacity: '0.2'
                  }}/>
              )
            }
          })
        }
      </div>
    </td>
  }

  getStyles = () => {
    const titleStyle = {
      fontWeight: '500',
      fontSize: '24px',
      textAlign: 'center',
      color: '#2F3235',
      marginBottom: '20px',
      marginTop: '20px',
      // textTransform: 'uppercase'
    }


    const textStyle = {
      fontWeight: '200',
      fontSize: '24px',
      textAlign: 'center',
      color: '#2F3235',
      marginBottom: '20px',
      marginTop: '20px',
      // textTransform: 'uppercase'
    }

    const tournamentStyle = {
      color: '#DC911B',
      fontSize: '24px',
      lineHeight: '29px',
      opacity: 0.6,
      textAlign: 'center',
      paddingTop: '40px'
    }

    const boldTitleStyle = {
      fontWeight: 'bold',
      fontSize: '48px',
      textAlign: 'center',
      color: COLORS.buttons,
      marginBottom: '20px',
      marginTop: '20px'
    }

    const teamStyle = {
      width: '70%',
      marginLeft: '50%',
      transform: 'translateX(-50%)',
      textAlign: 'center',
      borderRadius: '10px',
      marginTop: '20px',
      // textTransform: 'uppercase',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      color: '#DC911B',
      fontSize: '48px',
      fontWeight: '400',
      lineHeight: '58px'
    }

    const boxStyle = {
      backgroundColor: COLORS.main,
      width: '50%',
      height: 'auto',
      padding: '20px',
      borderRadius: '5px',
      // boxShadow: '0 -8px 80px 0 #4CB69E',
      position: 'absolute',
      left: '50%',
      top: '50%',
      transform: 'translate(-50%,-50%)',
      opacity: 1,
      overflow: 'hidden',
      maxWidth: '600px'
    }

    const cardStyle = {

    }

    const userStyle = {
      textAlign: 'center',
      marginTop: '10px',
      display: 'block',
      color: 'white',
      fontSize: '24px',
      lineHeight: '26px'
    }

    const pointStyle = {
      fontSize: '144px',
      color: 'white',
      textAlign: 'center',
      padding: '10px',
      fontWeight: 700,
      lineHeight: '173px',
      position: 'absolute',
      left: '50%',
      top: '50%',
      transform: 'translate(-50%, -50%)'
    }

    const pointBorderStyle = {
      width: '60%',
      paddingBottom: '60%',
      border : '1px solid #DC911B',
      borderRadius: '20px',
      margin: '20px auto',
      height: 0,
      position: 'relative',
      backgroundColor: 'rgba(47,50,53, 0.75)'
    }

    return {
      titleStyle,
      textStyle,
      boldTitleStyle,
      teamStyle,
      boxStyle,
      cardStyle,
      pointStyle,
      pointBorderStyle,
      userStyle,
      tournamentStyle
    }
  }

  renderPlayingPhase = (team1Name, team1Points, team1Member, team2Name, team2Points, team2Member) => {
    const styles = this.getStyles()

    let games = []
    Object.keys(this.state.runningGames).forEach(gameKey => {
      games.push(this.state.runningGames[gameKey])
    })

    if (games.length > 0) {
      games.sort((a,b) => {
        const aTime = Date.parse(a.lastUpdated)
        const bTime = Date.parse(b.lastUpdated)
        if (aTime > bTime) return 1
        else if (aTime < bTime) return -1
        else return 0
      })
    }

    // if (games.length < 10) {
    //   let i = 0
    //   while (i < 10 - Object.keys(this.state.runningGames).length) {
    //     games.push({type: 'emptyGame'})
    //     i++
    //   }
    // }
    // else {
    //   games = games.slice(- 10)
    // }

    return (
      <div style={{width: '100%'}}>
        <div onClick={() => { this.setState({singleGameViewOpen: !this.state.singleGameViewOpen}) }} style={{backgroundColor: '#DC911B', height: '80px', borderRadius: '5px', width: '10px', position: 'absolute', right: '15px', top: '50%', transform: `translate(${this.state.singleGameViewOpen ? -300 : 0}px, -50%)`, transition: 'transform 1s ease-in-out'}} />
        <div style={{height: 'calc(100% - 66px)', top: '66px', backgroundColor: '#DC911B', color: '#2F3235', width: '300px', position: 'absolute', right: '0px', willChange: 'transform', transform: `translateX(${this.state.singleGameViewOpen ? 0 : 300}px)`, transition: 'transform 1s ease-in-out'}}>
          <Button className={'closeBtn'} onClick={() => { this.setState({singleGameViewOpen: false}) }}>Schließen</Button>
          <div style={{width: '100%', marginBottom: '20px', paddingTop: '60px'}}>
            <Table>
              <tbody>
              <tr style={{padding: '10px 0', borderBottom: '1px solid rgba(47,50,53,0.27)'}}>
                <td style={{width: '20%', textAlign: 'left', fontSize: '18px', padding: '10px 0 10px 20px'}}>Spiele</td>
                <td style={{width: '40%', textAlign: 'left', fontSize: '24px', fontWeight: 'bold', padding: '10px'}}>{team1Name}</td>
                <td style={{width: '40%', textAlign: 'left', fontSize: '24px', fontWeight: 'bold', padding: '10px'}}>{team2Name}</td>
              </tr>

              {
                games && games.length > 0 && games.map((game, index) => {

                  // if (game.finished)
                  console.log('game', game)

                  const now = Date.now()
                  const lastUpdated = new Date(game.lastUpdated)
                  const lastUpdatedTime = lastUpdated.getTime()

                  console.log('hide game? ', now - lastUpdatedTime)

                  if (game.finished) {
                    if (now - lastUpdatedTime > OLD_GAME_TRESHHOLD) {
                      return null
                    }
                  }

                  let user1IsChallenger = true
                  let user1ToRender = team1Member.find(teamMember => teamMember.id === game.challenger)
                  if (!user1ToRender) {
                    user1IsChallenger = false
                  }

                  let user2IsChallenger = true
                  let userToRender = team2Member.find(teamMember => teamMember.id === game.challenger)
                  if (!userToRender) {
                    user2IsChallenger = false
                  }

                  return (
                    <tr style={{padding: '10px 0', borderBottom: '1px solid rgba(47,50,53,0.27)'}}>
                      <td style={{width: '20%', textAlign: 'left', fontSize: '18px', padding: '10px 0 10px 20px'}}>{index + 1}</td>
                      { this.renderGame(team1Name, team2Name, game, user1IsChallenger) }
                      { this.renderGame(team1Name, team2Name, game, user2IsChallenger) }
                    </tr>
                  )
                })
              }
              </tbody>
            </Table>
          </div>
        </div>
        <div style={{maxWidth: '50%', margin: '0 auto', paddingTop: '20px', paddingBottom: '20px', position: 'relative'}}>
          <div style={styles.tournamentStyle}>Turnier</div>
          <div style={styles.teamStyle}>
            {this.state.chosenTournament.name}
          </div>
          <div>
            <div style={{width: '50%', position: 'absolute', left: 0}}>
              <div style={styles.tournamentStyle}>Team</div>
              <div style={styles.teamStyle}>
                {team1Name}
              </div>
              <div style={this.state.phase === TOURNAMENT_PHASES.END && team1Points >= team2Points ? Object.assign({}, styles.pointBorderStyle, {backgroundColor: '#DC911B'}) : styles.pointBorderStyle}>
                <div style={styles.pointStyle}>
                  {team1Points}
                </div>
              </div>
              {this.state.phase === TOURNAMENT_PHASES.END && team1Points > team2Points &&
              <div style={{textAlign: 'center', color: '#DC911B', fontSize: '24px'}}>Gewinner</div>
              }
            </div>
            <div style={{width: '50%', position: 'absolute', fontSize: '144px', color: '#DC911B', left: '50%', transform: 'translateX(-50%)', fontFamily: 'Roboto'}}>
              <div style={styles.tournamentStyle}>&nbsp;</div>
              <div style={styles.teamStyle}>&nbsp;</div>
              <div style={Object.assign({}, styles.pointBorderStyle, {border: 0, backgroundColor: 'transparent'})}>
                <div style={Object.assign({}, styles.pointStyle, {color: '#DC911B'})}>
                  :
                </div>
              </div>
              {this.state.phase === TOURNAMENT_PHASES.END && team2Points === team1Points &&
              <div style={{textAlign: 'center', color: '#DC911B', fontSize: '24px'}}>Unentschieden</div>
              }
            </div>
            <div style={{width: '50%', position: 'absolute', right: 0}}>
              <div style={styles.tournamentStyle}>Team</div>
              <div style={styles.teamStyle}>
                {team2Name}
              </div>
              <div style={this.state.phase === TOURNAMENT_PHASES.END && team2Points >= team1Points ? Object.assign({}, styles.pointBorderStyle, {backgroundColor: '#DC911B'}) : styles.pointBorderStyle}>
                <div style={styles.pointStyle}>
                  {team2Points}
                </div>
              </div>
              {this.state.phase === TOURNAMENT_PHASES.END && team2Points > team1Points &&
              <div style={{textAlign: 'center', color: '#DC911B', fontSize: '24px'}}>Gewinner</div>
              }
            </div>
          </div>
          {this.state.showExtraTimeWarning && this.state.phase === TOURNAMENT_PHASES.WAIT_FOR_END &&
          <div style={{position: 'fixed', left: 0, top: 0, right: 0, bottom: 0, backgroundColor: 'rgba(47, 50, 53, 0.6)'}}>
            <div style={styles.boxStyle}>
              <div style={styles.titleStyle}>Nachspielzeit</div>
              <div style={Object.assign({}, styles.textStyle, {marginBottom: '70px'})}>Bitte beende Deine noch laufenden Spiele.</div>
              <Button
                onClick={() => { this.setState({showExtraTimeWarning: false}) }}
                className={'okBtn'}
              >
                OK
              </Button>
            </div>
          </div>
          }
        </div>
      </div>
    )
  }

  renderContentByPhase = () => {
    const teamsKeys = this.state.tournamentData && this.state.tournamentData.teams ? Object.keys(this.state.tournamentData.teams) : []

    const styles = this.getStyles()

    let data = []
    const team1Obj = teamsKeys.length > 0 ? this.state.tournamentData.teams[teamsKeys[0]] : null
    const team1Name = team1Obj ? team1Obj.name : 'Team1'
    let team1Points = team1Obj ? this.state.teamPoints && this.state.teamPoints[team1Obj.name] ? this.state.teamPoints[team1Obj.name] :  team1Obj.points : 0
    const team1Member = team1Obj ? team1Obj.members : []
    const team2Obj = teamsKeys.length > 0 ? this.state.tournamentData.teams[teamsKeys[1]] : null
    const team2Name = team2Obj ? team2Obj.name : 'Team2'
    let team2Points = team2Obj ? this.state.teamPoints && this.state.teamPoints[team2Obj.name] ? this.state.teamPoints[team2Obj.name] : team2Obj.points : 0
    const team2Member = team2Obj ? team2Obj.members : []
    data.push({name: team1Name, value: team1Points})
    data.push({name: team2Name, value: team2Points})

    if (this.state.phase === TOURNAMENT_PHASES.CHOOSE_TEAM || this.state.phase === TOURNAMENT_PHASES.WAIT_FOR_PLAYING) {
      return (
        <div>
          <div style={{width: '100%'}}>
            <div style={styles.tournamentStyle}>Turnier</div>
            <div style={Object.assign({}, styles.teamStyle, {width: '70%'})}>
              {this.state.chosenTournament.name}
            </div>
            <div style={Object.assign({}, styles.titleStyle, {paddingTop: '20px'})}>{this.state.phase === TOURNAMENT_PHASES.CHOOSE_TEAM
              ? 'Teamauswahl'
              : 'Die Teams sind verteilt, das Spiel wird gestartet...'}
            </div>
            <div>

            </div>
            <div style={{width: '50%', display: 'inline-block', position: 'absolute', left: 0}}>
              <div style={{textAlign: 'center', fontSize: '20px'}}>
                <div style={styles.tournamentStyle}>Team</div>
                <div style={styles.teamStyle}>{team1Name}</div>
              </div>
              <div style={styles.userStyle}>
                {team1Member.map(member => {
                  return (
                    <div key={member.id}>{member.nickname}</div>
                  )
                })}
              </div>
            </div>
            <div style={{width: '50%', display: 'inline-block', position: 'absolute', right: 0}}>
              <div style={{textAlign: 'center', fontSize: '20px'}}>
                <div style={styles.tournamentStyle}>Team</div>
                <div style={styles.teamStyle}>{team2Name}</div>
              </div>
              <div style={styles.userStyle}>
                {team2Member.map(member => {
                  return (
                    <div key={member.id}>{member.nickname}</div>
                  )
                })}
              </div>
            </div>
          </div>
        </div>
      )
    }
    else if (this.state.phase === TOURNAMENT_PHASES.PLAY_GAMES || this.state.phase === TOURNAMENT_PHASES.WAIT_FOR_END || this.state.phase === TOURNAMENT_PHASES.END) {
      return this.renderPlayingPhase(team1Name, team1Points, team1Member, team2Name, team2Points, team2Member)
    }
  }

  backButtonFn = async () => {
    if (this.state.activated && this.state.tournamentChosen) {
      console.log('back button pressed')
      this.setState({gotTournamentData: false, tournamentChosen: false, runningTime: null})
      clearInterval(this.runningTimeInterval)
      await this.getTournamentList()
    }
    else if (this.state.activated && !this.state.tournamentChosen) {
      this.setState({activated: false})
    }
  }

  render () {
    let content

    const styles = this.getStyles()

    if (!this.state.activated) {
      content =
        <div style={styles.boxStyle}>
          <div style={styles.titleStyle}>Geben Sie hier den Zugangscode zum Dashboard ein</div>
          <FormControl className={'activateTextfield'}>
            <InputLabel
              htmlFor="input"
              style={{color: '#2F3235 !important'}}
              FormLabelClasses={{
                root: 'activateInputRoot',
                focused: 'activateFocused'
              }}
            >
            </InputLabel>
            <Input
              id="input"
              className={'activateInput'}
              classes={{
                underline: 'underline'
              }}
              style={{width: '100%', fontSize: '24px'}}
              onChange={this.changeActivationCode}
              value={this.state.activationCode}
            />
          </FormControl>
          <Button
            onClick={this.resetActivationCodeEntry}
            className={'cancelBtn'}
          >
            Abbrechen
          </Button>
          <Button
            onClick={this.activate}
            className={'activateBtn'}
          >
            Weiter
          </Button>
        </div>
    }
    else if (this.state.activated && !this.state.tournamentChosen && !this.state.gotTournamentData) {
      content = this.showTournamentChooser()
    }
    else if (this.state.activated && this.state.tournamentChosen && !this.state.gotTournamentData) {
      content = <div style={{position: 'absolute', left: '50%', top: '50%', transform: 'translate(-50%, -50%)'}}>
        <div>Lade Daten</div>
        <div style={{width: '100%', margin: '0 auto'}}>
          <CircularProgress />
        </div>
      </div>
    }
    else {
      content = <div>{this.renderContentByPhase()}</div>
    }

    const error = this.state.error ? <div style={{margin: '20px', color: 'red', fontWeight: 'bold', fontSize: '16px', textAlign: 'center'}}>Es ist ein Fehler aufgetreten: {this.state.error}</div> : null

    return (
      <Page
        isActivated={this.state.tournamentChosen}
        backButtonFunc={this.backButtonFn}
      >
        {error}
        {content}
      </Page>
    )
  }

}

export default withHighcharts(Home, Highcharts)



// WEBPACK FOOTER //
// ./src/pages/Home.js